<template>
    <v-card flat color="grey-f7" height="640" width="320" class="d-flex flex-column" v-bind="{ loading }">
        <v-list style="flex-grow: 0" color="transparent">
            <v-list-item class="py-0 px-16">
                <v-list-item-avatar color="white" rounded>
                    <v-img>
                        <template #placeholder>
                            <v-icon>mdi-domain</v-icon>
                        </template>
                    </v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title> 마이스펙 챗봇 </v-list-item-title>
                    <v-list-item-subtitle>
                        <v-btn x-small> 사용안내 </v-btn>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-card-text class="pt-0 px-16" style="flex-grow: 1; flex-shrink: 1; overflow: hidden">
            <view-messages />
        </v-card-text>
        <v-card-actions>
            <v-text-field v-model="query" v-bind="inputAttrs" flat solo rounded @keydown.enter="send">
                <template #append>
                    <v-btn x-small rounded fab color="primary" v-bind="inputAttrs" class="mr-n8" @click="send">
                        <v-icon small>mdi-send</v-icon>
                    </v-btn>
                </template>
            </v-text-field>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import ViewMessages from "./view/view-messages.vue";

export default {
    components: {
        ViewMessages,
    },
    data: () => ({
        query: null,
    }),
    computed: {
        ...mapState("chat", ["room", "loading"]),
        ...mapGetters("chat", ["loading__lastMessage"]),
        inputAttrs() {
            let { loading } = this;
            loading = loading || this.loading__lastMessage;
            return {
                loading,
                disabled: loading,
            };
        },
    },
    methods: {
        ...mapActions("chat", ["init", "sendQuery"]),
        send() {
            let { query } = this;
            this.sendQuery({ query });
            this.query = null;
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
::v-deep .v-input__slot {
    padding: 0 16px !important;
}
</style>